import { TAPIError, TAPIPayload } from '@myua/api';
import { TAPIErrorSchema } from '@myua/api/dist/types';
import { Interrupt } from './scenarioFactory';

// returns
export type TAPIReturnSuccess<S = any> = { success: true; data: TAPIPayload<S>; args: any };
export type TAPIReturnError = {
  success: false;
  errorData?: TAPIError;
  reason: Interrupt;
  args: any;
};
// альтернативный генератор саг, совместимый со стандартными сценариями, имеет другую сигнатуру у возвращаемого значения
export type APIScenarioReturn<T = any> = TAPIReturnSuccess<T> | TAPIReturnError;

export function APIScenarioFactory<TResponse, TParams extends any[]>(
  api: (...args: TParams) => Promise<TAPIPayload<TResponse>>,
) {
  return async function (...args: TParams): Promise<APIScenarioReturn<TResponse>> {
    try {
      const payload = await api(...args);
      return { success: true, data: payload, args };
    } catch (reason) {
      if (reason instanceof Error) {
        return { success: false, args, reason: Interrupt.Exception(reason.message) };
      }
      const maybeError = TAPIErrorSchema.safeParse(reason);
      if (maybeError.success) {
        return {
          success: false,
          args,
          errorData: maybeError.data,
          reason: Interrupt.API,
        };
      }
      return {
        success: false,
        args,
        reason: Interrupt.Exception('unknown error, see saga factory'),
      };
    }
  };
}
